import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { FileSaverService } from 'ngx-filesaver';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExportService {
  constructor(private fs: FileSaverService) {}

exportExcel(req: any) {
  const subjectCount = req.subjectCount || 8;
  const year = req.year
  const month = req.month
  const semester = req.semester

  // Build courseSubjects dynamically if available in req
  const fullSheet: any[][] = [];
  fullSheet.push(['', '','', 'GOVERNMENT OF KARNATAKA']);
  fullSheet.push(['', '','', 'DEPARTMENT OF COLLEGIATE AND TECHENICAL EDUCATION']);
  fullSheet.push(['', '','', 'BOARD OF TECHENICAL EXAMINATIONS, BANGALORE']);
  fullSheet.push(['', '','', 'B.V.V.S POLYTECHENIC(AUTONOMOUS), BAGALKOT']);
  fullSheet.push(['', '', '', `PROVISIONAL MARKS SHEET- ${semester} EXAMINATION- ${month}-${year}`]);
    // 1. Course Subjects
    if (req.subject_metadata_rows && Array.isArray(req.subject_metadata_rows)) {
  // Header Row: ['', '', 'Sub1', 'Sub1 Grade', '', 'Sub2', 'Sub2 Grade', '', ...]
  const headerRow = ['', ...Array.from({ length: subjectCount }, (_, i) => {
  const subIdx = i + 1;
  return [`0${subIdx}`, ``]; // ✅ No blank spacer column
}).flat()];
  fullSheet.push(headerRow);

  // Add each metadata row
 
  const metadataLabels = [
  'Name of the Candidate',
  'SL No   Register No',
  'IA Max Marks',
  'IA Min Marks',
  'End Exam Max',
  'End Exam Min',
  'Total Max Marks',
  'Total Min Marks',
  'Credits'
];


  req.subject_metadata_rows.forEach((row: string[], rowIndex: number) => {
  const label = metadataLabels[rowIndex] ?? '';
  const formattedRow = [label, ...Array.from({ length: subjectCount }, (_, i) => {
    const iaValue = row[i * 2 + 2] ?? '--';
    const gradeValue = row[i * 2 + 3] ?? '--';
    return [iaValue, gradeValue];
  }).flat()];

  
  fullSheet.push(formattedRow);
});

  fullSheet.push([]); // spacer after section
}

  // Summary fields as top-level headers (not per student)
  const summaryFields = [
    'total_earned_credits',
    'weighted_grade_points',
    'cumulative_credits_earned',
    'sgpa',
    'cgpa',
    'total_percentage',
    'overall_result'
  ];

  // Create header row
  const headers = ['Student Name'];
  for (let i = 1; i <= subjectCount; i++) {
    headers.push(`Sub${i}`);
    headers.push(`Sub${i} Grade`);
  }
  headers.push(...summaryFields.map(this.formatLabel));
  fullSheet.push(headers);

  // Student rows
  req.data.forEach((row: any) => {
  const row1: any[] = [row.name ?? '--']; // Row 1: Student Name
  const row2: any[] = [row.register_no ?? '--']; // Row 2: Register No
  const row3: any[] = ['']; // Row 3: Result row (placeholder)

  for (let i = 1; i <= subjectCount; i++) {
    const ia = row[`ia_sub${i}`] ?? '--';
    const see = row[`see_sub${i}`] ?? '--';
    const result = row[`result_sub${i}`] ?? '--';
    const grade = row[`grade_sub${i}`] ?? '--';

    row1.push(ia);       // Row 1: IA (used to be SEE originally)
    row1.push(grade);    // Row 1: Grade
    row2.push(see);      // Row 2: SEE (used to be IA originally)
    row2.push('');
    row3.push(result);   // Row 3: Result
    row3.push('');
  }

  // Append summary fields only in row1, and align others with empty values
  summaryFields.forEach(field => {
    const value = row[field] ?? '--';
    row1.push(value);
    row2.push('');
    row3.push('');
  });

  fullSheet.push(row1);
  fullSheet.push(row2);
  fullSheet.push(row3);
  fullSheet.push([]);
});

  // Generate Excel
  const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(fullSheet);
  const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
  const buffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob: Blob = new Blob([buffer], { type: EXCEL_TYPE });
  this.fs.save(blob, `${req.filename}_export_${Date.now()}${EXCEL_EXTENSION}`);
}


  private formatLabel(key: string): string {
    return key
      .replace(/_/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  }
}
